<style src="./ResponsabilitiesMap.scss" lang="scss" scoped></style>
<template>
  <section class="client-map">
    <ul class="grid-list-container">
      <li class="grid-list-header">
        <ul>
          <li class="col-10">Nome</li>
          <li class="col-2">
            <page-navigator
              @gotonextpage="goToNextPage"
              @gotopreviouspage="goToPreviousPage"/>
          </li>
        </ul>
      </li>

      <li class="grid-list-item" v-for="item, itemIdx in listDataPaginated" :key="itemIdx">
        <ul>
          <li class="col-10">{{ item.shortName }}</li>
          <li class="col-1 center">
            <button class="column-button" @click="edit(indexList)">
              <icon-edit />
            </button>
          </li>
          <li class="col-1 center">
            <button-remove @remove="removeItem(indexList)"/>
          </li>
        </ul>
      </li>
    </ul>
  </section>
</template>

<script>
import { ButtonRemove, PaginatorMixin, PageNavigator } from '@/components/primitives'
import { IconEdit, IconLock } from '@/components/primitives/icons'

export default {
  name: 'ResponsabilitiesMap',
  components: {
    PageNavigator,
    ButtonRemove,
    IconEdit,
    IconLock
  },
  extends: {
    ...PaginatorMixin
  },
  data () {
    return {}
  },
  mounted () {},
  methods: {
    edit (pId) {}
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/responsabilities/components/responsabilities-map/ResponsabilitiesMap.vue